import React, { FC } from 'react'

import { useRouter } from 'next/navigation'

import { LinkTxt } from 'src/components/molecules'

import { Routes } from 'src/routes'

type Props = {
  preAction?: () => Promise<void>
  className?: string
}

export const BackToSignInLinkTxt: FC<Props> = ({ preAction, className }) => {
  const router = useRouter()

  const onClick = async () => {
    preAction && (await preAction())
    router.push(Routes.SignIn.path)
  }

  return (
    <div className={className}>
      <LinkTxt
        sizeType="s"
        className="tw-text-center"
        prependIconPath="back/soft/line"
        underlineType="onlyDefault"
        onClick={onClick}
      >
        ログインへ戻る
      </LinkTxt>
    </div>
  )
}
